import { useTheme } from "./ThemeContext"

export default function AboutMe() {
  const { theme } = useTheme()

  return (
    <section
      id="about"
      className={`py-16 px-4 transition-colors duration-300 ${
        theme === "dark" ? "bg-gradient-to-r from-gray-900 to-blue-900" : "bg-gradient-to-r from-blue-500 to-purple-600"
      }`}
    >
      <div className="max-w-6xl mx-auto">
        <h2 className="text-5xl lg:text-6xl font-bold text-yellow-400 text-center mb-12">About Me</h2>

        <div className="space-y-8 text-center">
          <p
            className={`text-lg lg:text-xl leading-relaxed transition-colors duration-300 ${
              theme === "dark" ? "text-gray-200" : "text-white"
            }`}
          >
            I'm a dedicated software engineer with a passion for web development and problem-solving. Currently working
            as a Junior Software Engineer in .NET development, I focus on creating efficient, scalable web applications.
          </p>

          <p
            className={`text-lg lg:text-xl leading-relaxed transition-colors duration-300 ${
              theme === "dark" ? "text-gray-200" : "text-white"
            }`}
          >
            Skilled in .NET, JavaScript, AJAX, Web API, and MySQL. I enjoy working across the full stack to build
            responsive and user-friendly web solutions.
          </p>

          <p
            className={`text-lg lg:text-xl leading-relaxed transition-colors duration-300 ${
              theme === "dark" ? "text-gray-200" : "text-white"
            }`}
          >
            I earned my B.Tech in Computer Science from RKGIT, Ghaziabad (2020-2024), where I gained strong fundamentals
            in DSA, algorithms, web development, DBMS, and other core CS subjects.
          </p>
        </div>
      </div>
    </section>
  )
}